import { api } from '../DefaultService';
import { RegisterFormSchema } from './schemas';
import {
  IAuthLoginProps,
  IAuthRegisterProps,
  IQRCodeLoginParams,
} from './types';
import zod from 'zod';

type SignUpFormData = zod.infer<typeof RegisterFormSchema>;

const ENDPOINT = '/v1/auth';

export const doLoginAsync = async (data: IAuthLoginProps): Promise<void> => {
  await api
    .post(`${ENDPOINT}/login`, data)
    .then((res) => {
      const token = res.data;
      sessionStorage.setItem('token', window.btoa(token));
      api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    })
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const doFirebaseAuthAsync = async (): Promise<void> => {
  await api
    .get(`${ENDPOINT}/firebasetoken`)
    .then((res) => {
      const token = res.data;
      sessionStorage.setItem('firebaseToken', window.btoa(token));
    })
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const doRegisterAsync = async (data: SignUpFormData): Promise<void> => {
  await api.post(`${ENDPOINT}/register`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const doInternalRegisterAsync = async (
  data: IAuthRegisterProps,
): Promise<void> => {
  await api.post(`${ENDPOINT}/register`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const QRCodeLoginAsync = async ({
  token,
  data,
}: IQRCodeLoginParams): Promise<void> => {
  await api
    .post(`${ENDPOINT}/account/QRCode/login/${token}`, data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
